import React, { useEffect } from 'react';
import AOS from 'aos';

import Home from './HomePage';
import About from './About';
import Team from './Team';
import Contact from './Contact';
import Services from './Services';
import OurClients from './Clients';
import Courses from './Courses';

const LandingPage = () => {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  return (
    <>
      <section id="home"><Home /></section>
      <section id="courses"><Courses /></section>
      <section id="about"><About /></section>
      <section id="services"><Services /></section>
      <section id="team"><Team /></section>
      <section id="contact"><Contact /></section>
      <section id="Clients"><OurClients /></section>
    </>
  );
};

export default LandingPage;
